import { IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { ChangesType } from "../../types";
import { updateObject } from "../../../common/util/UpdateObject";

export const changesLoadingPartialReducer: IPartialReducer<ChangesType> = (state) => {
    return updateObject(state, {
        changesLoad: {
            loading: true,
        },
    });
};
